import React from 'react';
import { useTheme } from './ThemeProvider';
import { useTranslation } from 'react-i18next';

/**
 * Dark Mode Toggle Button
 */
export default function DarkModeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-lg transition-colors hover:bg-neutral-200 dark:hover:bg-neutral-700 ${className}`}
      aria-label={theme === 'dark' ? t('header.lightMode') : t('header.darkMode')}
      title={theme === 'dark' ? t('header.lightMode') : t('header.darkMode')}
    >
      {theme === 'dark' ? (
        // Sun icon for light mode
        <svg
          className="w-5 h-5 text-yellow-500"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
        </svg>
      ) : (
        // Moon icon for dark mode
        <svg
          className="w-5 h-5 text-neutral-700"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
        </svg>
      )}
    </button>
  );
}
